import { logout, refresh } from '@/services/authService';
import { defineStore } from 'pinia';

interface User {
  id: string;
  orgId: string;
  orgRole: string;
  email: string;
  name: string;
  isSystemAdmin: boolean;
  organization: Organization;
}

interface Organization {
  id: string
  logo_url: string
  name: string
  plan_type: string
  slug: string
  subscription_status: string
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as User | null,
    accessToken: null as string | null,
    isInitialized: false,
  }),

  getters: {
    isLoggedIn: (state) => !!state.accessToken && !!state.user,
  },

  actions: {
    setAuth(access: string, user: any) {
      this.accessToken = access;
      this.user = user;
    },
    async logout() {
      const res = await logout();
      console.log(res);
      localStorage.removeItem("token");
      this.clearAuth();
    },
    async refresh() {
      try {
        const res = await refresh();
        if (res.ok) {
          const data = await res.json();
          this.accessToken = data.access_token;
          this.user = data.user;
          return true;
        } else {
          this.clearAuth();
          return false;
        }
      } catch (e) {
        console.error('Errore durante il refresh', e);
        this.clearAuth();
        return false;
      } finally {
        this.isInitialized = true;
      }
    },
    clearAuth() {
      this.accessToken = null;
      this.user = null;
      this.isInitialized = false;
    }
  },
});